var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.491 10.644L4.783 19.377 18.49 28.11l13.71-8.733zm27.419 0L32.2 19.377l13.71 8.733 13.708-8.733zm-41.127 26.2l13.709 8.733L32.2 36.844 18.492 28.11zm41.126-8.734L32.2 36.845l13.709 8.733 13.709-8.733zM18.491 48.488l13.71 8.734 13.708-8.734L32.2 39.756z",
    fill: "#0061FF"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0wIDBoNjR2NjRIMHoiLz48cGF0aCBkPSJNMTguNDkxIDEwLjY0NEw0Ljc4MyAxOS4zNzcgMTguNDkgMjguMTFsMTMuNzEtOC43MzN6bTI3LjQxOSAwTDMyLjIgMTkuMzc3bDEzLjcxIDguNzMzIDEzLjcwOC04LjczM3ptLTQxLjEyNyAyNi4ybDEzLjcwOSA4LjczM0wzMi4yIDM2Ljg0NCAxOC40OTIgMjguMTF6bTQxLjEyNi04LjczNEwzMi4yIDM2Ljg0NWwxMy43MDkgOC43MzMgMTMuNzA5LTguNzMzek0xOC40OTEgNDguNDg4bDEzLjcxIDguNzM0IDEzLjcwOC04LjczNEwzMi4yIDM5Ljc1NnoiIGZpbGw9IiMwMDYxRkYiLz48L2c+PC9zdmc+";
export { SvgDropbox as ReactComponent };